import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import App from "./App.tsx";
import "./index.css";
import { cleanupStaleServiceWorkersOnBoot } from "./lib/cacheCleanup";
import { installBuildMeta } from "./lib/buildInfo";
import { startVersionCheck } from "./lib/versionCheck";
import { prefetchLikelyRoutes } from "./components/PrefetchLink";

// Important: do NOT register a service worker here. FinPlay previously shipped
// a PWA worker that could serve stale UI, so boot only performs safe cleanup of
// service workers + CacheStorage. It never clears local/session storage.
cleanupStaleServiceWorkersOnBoot();

// Stamp the current build id into <head> so reviewers and the version poller
// can verify which build is loaded.
installBuildMeta();

// Politely notify the user (via toast, no auto-reload) when a new build ships.
startVersionCheck();

createRoot(document.getElementById("root")!).render(
  <HelmetProvider>
    <App />
  </HelmetProvider>
);

// Warm the "big 4" route chunks during idle time so the first navigation
// after landing on `/` is instant. Safe: pure code-splitting prefetch.
prefetchLikelyRoutes([
  "/dashboard",
  "/financial-league",
  "/financial-tinder",
  "/community",
]);

